import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from 'utils/authSlice';

/**
 * Hook qui vérifie automatiquement l'expiration du token JWT
 * Logout automatique quand le token expire
 */
const useAuthTokenManager = () => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!token) return;

    // Fonction pour décoder le JWT et vérifier l'expiration
    const checkTokenExpiration = () => {
      try {
        // Décoder le JWT (format: header.payload.signature)
        const parts = token.split('.');
        if (parts.length !== 3) {
          console.error('Token invalide');
          dispatch(logout());
          return;
        }

        // Décoder le payload
        const payload = JSON.parse(atob(parts[1]));
        const expirationTime = payload.exp * 1000; // Convertir en millisecondes
        const now = new Date().getTime();

        // Si le token a expiré
        if (now >= expirationTime) {
          console.warn('Token expiré - Logout automatique');
          dispatch(logout());
          return;
        }

        // Calculer le temps jusqu'à l'expiration
        const timeUntilExpiration = expirationTime - now;

        // Vérifier toutes les minutes (ou 5 minutes avant l'expiration)
        const checkInterval = Math.min(60000, timeUntilExpiration - 300000);
        
        const timer = setInterval(() => {
          checkTokenExpiration();
        }, checkInterval > 0 ? checkInterval : 60000);

        return () => clearInterval(timer);
      } catch (error) {
        console.error('Erreur lors de la vérification du token:', error);
        dispatch(logout());
      }
    };

    // Vérifier immédiatement
    checkTokenExpiration();
  }, [token, dispatch]);
};

export default useAuthTokenManager;
